import ShippingAddressForm, { ShippingAddressFormComponent } from './ShippingAddressForm';

export default ShippingAddressForm;
export { ShippingAddressFormComponent };
